import { createAction } from '@reduxjs/toolkit';
import { IBroadcastMessagesState } from '@store/broadcast-messages/types';

export class CreateMessageSuccess {
  static get action() {
    return createAction('broadcastMessages/CREATE_MESSAGE_SUCCESS');
  }

  static get reducer() {
    return (draft: IBroadcastMessagesState) => {
      draft.requests.getBroadcastMessagesPending = false;
      return draft;
    };
  }
}
